











import Vue from 'vue'
import { getProviderCredit } from '@/api/Topup/topup.api'
import ActionButton from '@/components/ActionButton.vue'

export default Vue.extend({
  components: {
    appActionButton: ActionButton,
  },
  props: {
    uuid: String,
    agency: String,
  },
  data() {
    return {
      provider: {},
      loading: false,
    }
  },
  methods: {
    async getCredit() {
      try {
        this.loading = true
        const response = await getProviderCredit(this.uuid, {
          agency__uuid: this.agency,
        })
        this.provider = response.data
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    uuid(value) {
      if (value) {
        this.getCredit()
      }
    },
    agency(value) {
      this.getCredit()
    },
  },
  mounted() {
    this.getCredit()
  },
})
